


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { DoceboCourseType } from '@/lib/DoceboAPI';

@Component
export default class CourseType extends Vue {
  private DoceboCourseType = DoceboCourseType;

  @Prop() type!: DoceboCourseType;
}
